import { Component } from '@angular/core';
import { EaccessAuthService } from '../auth/eaccess-auth.service';
import { ROLE_COMPLIANCE } from '../shared/constants';

@Component({
  selector: 'eaa-can-view-mappings',
  template: `
    @if (canView) {
      <ng-content></ng-content>
    }
  `
})
export class CanViewMappingsComponent {
  public canView: boolean | null = null;

  constructor(private authService: EaccessAuthService) {}

  ngOnInit(): void {
    this.authService.hasRole$(ROLE_COMPLIANCE).subscribe((hasRole) => (this.canView = hasRole));
  }
}
